import GameScene from '../Inamove/Components/GameScene/GameScene'
import dispatch from '../Inamove/Utility/dispatchAction'
import { waypointOpenActionCreator } from '../Inamove/Components/Waypoint'
import CinematicContainer from '../Inamove/Containers/CinematicContainer/CinematicContainer'
import LoadingContainer from '../Inamove/Containers/LoadingContainer/LoadingContainer'
import Video from '../Inamove/Components/Video/Video'
import AudioController from '../Inamove/Controllers/AudioController'

/*
 * toggles the accessibility of a waypoint. can hide interactable objects in a gamescene
 */
export function toggleWaypoint(waypointId: string, show: boolean, unlock: boolean, gameScene: GameScene) {
    const waypoint = document.getElementById(waypointId)
    if (waypoint) {
        //Wegpunkt entsprechend verstecken oder anzeigen
        show ? gameScene.showWaypoint(waypointId) : gameScene.hideWaypoint(waypointId)
        //wegpunkt aufschließen
        if (unlock) dispatch(waypointOpenActionCreator(waypointId))
    } else {
        console.error('waypoint is ' + typeof waypoint)
    }
}

//setzt eine Verzögerung in milliseconds -> vorher kann nicht interagiert werden (await delay(time))
export async function delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms))
}

// handles all the important stuff to play a video file
export async function playVideo(video: Video) {
    LoadingContainer.hide()
    CinematicContainer.setVideo(video)

    AudioController.setMute(true)
    CinematicContainer.show()

    await CinematicContainer.play()

    CinematicContainer.hide()
    AudioController.setMute(false)
}

/* changes opacity of all HTML Elements with targetClass based on the distance between the cursor and the center of the overlayImages
* @params overlayImages - svg ids for the images.
* @params minDist - distance from center at which opacity = 1
* @params targetClass - class of HTML Elements that will become transparent
* @params invisOnLeave - whether to change the opacity to 0 once the cursor leaves the image
* @params distFunction - function to calculate the two dimensional distance, returns distance between x_1 = 0.5, y_1 0.5 (middle of HTML Elements) and x, y
* @params opacityFunction - function to calculate the opacity based on the distance. return calculated opacity as a string

*/
export function spooky(
    overlayImages: string[],
    minDist: number,
    targetClass: string,
    invisOnLeave: boolean,
    baseOpacity?: number,
    distFunction?: (x: number, y: number) => number,
    opacityFunction?: (dist: number) => string
) {
    if (!baseOpacity) baseOpacity = 0
    for (const spookyImage of overlayImages) {
        const polygon = document.getElementById(spookyImage)
        polygon?.addEventListener('mousemove', (event) => {
            const target = event.target as HTMLElement
            const rect = target.getBoundingClientRect()
            //Zentrum des Elements finden
            const x = (event.clientX - rect.left) / rect.width
            const y = (event.clientY - rect.top) / rect.height

            let dist = -1 //for error catching

            //Distanz berechnen
            if (distFunction) {
                dist = distFunction(x, y)
            } else {
                dist = Math.sqrt(Math.pow(0.5 - x, 2) + Math.pow(0.5 - y, 2))
            }

            //Sichtbarkeit berechnen
            let opacity = baseOpacity?.toString()
            if (dist <= minDist) {
                opacity = '1'
            } else {
                if (opacityFunction) {
                    opacity = opacityFunction(dist)
                } else {
                    opacity = (1 - dist * 2).toString()
                }
            }
            //Style entsprechend anpassen
            const v = document.getElementsByClassName(targetClass) as HTMLCollectionOf<HTMLElement>
            for (let i = 0; i < v.length; i++) {
                v[i].style.opacity = opacity.toString()
            }
        })
        if (invisOnLeave) {
            polygon?.addEventListener('mouseleave', () => {
                const v = document.getElementsByClassName(targetClass) as HTMLCollectionOf<HTMLElement>
                for (let i = 0; i < v.length; i++) {
                    v[i].style.opacity = '0'
                }
            })
        }
    }
}

//funktioniert wie toggleWegpunkt, nur dass man mehrere Wegpunkte und Kulissen iterieren kann
export function toggleKulissen(
    gameScenesWithWaypoint: GameScene[],
    waypoints: string[],
    show: boolean,
    verbose?: boolean
) {
    for (const gs of gameScenesWithWaypoint) {
        for (const waypoint of waypoints) {
            const poly = document.getElementsByTagName('polygon').namedItem(waypoint)
            const showMsg = show ? 'Showing in ' : 'Hiding in '
            if (verbose) console.debug(showMsg + gs.id + ': ' + poly?.outerHTML)
            show ? gs.showWaypoint(waypoint) : gs.hideWaypoint(waypoint)
        }
    }
}
